import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { searchCraftAPI } from "../../../api/service";
import { ISearchTemplateSlice } from "../../../api/craft/model/ISearchTemplateSlice";

const INITIAL_STATE = {
  response: null,
  loading: false,
  error: null,
  status: "idle",
} as ISearchTemplateSlice;

export const _searchTemplateByName = createAsyncThunk(
  "api/craftmanagement/SearchTemplateByName",
  searchCraftAPI.searchTemplateByName
);

export const searchTemplateByNameSlice = createSlice({
  name: "searchTemplateByName",
  initialState: INITIAL_STATE,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(_searchTemplateByName.pending, (state) => {
        state.loading = true;
        state.status = "loading";
      })
      .addCase(_searchTemplateByName.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
        state.response = action.payload.data;
        state.status = "succeeded";
      })
      .addCase(_searchTemplateByName.rejected, (state, action) => {
        state.loading = false;
        state.response = null;
        state.error = action.payload;
        state.status = "failed";
      });
  },
});
